import React, { useState, useEffect } from 'react'
import './Timeline.css'
import { useTranslation } from 'react-i18next'
import { RiSettings5Line } from 'react-icons/ri'
import moment from 'moment'
import { Link } from 'components/common'
import { useHistory } from 'react-router-dom'
import { useContext } from 'react'
import { TubularContext } from 'stores/TubularStore'

const ProcessingCard = ({ data }) => {
    const { t } = useTranslation()
    const history = useHistory()
    const [selectDetail, setSelectDetail] = useState('')
    const { setValueData } = useContext(TubularContext)

    useEffect(() => {
        if (selectDetail === 'sot') {
            setValueData(data.detail['Service Order'])
            history.push("/sot/" + data.detail['Service Order'])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectDetail, history])

    const toGo = (value) => {
        setSelectDetail(value)
    }
    const content =
        <div className="timeline-item-content">
            <span className="title">
                <RiSettings5Line className="icon" />
                {t('tlh.ippn.processing.title')}
            </span>
            <section className="container row">
                <div className="item">
                    <span className="label">{t('tlh.ippn.processing.serviceOrder')}: </span>
                    <span className="value">
                        <Link onClick={() => toGo('sot')}>
                            {data.detail['Service Order']}
                        </Link>
                    </span>
                </div>
            </section>
            <section className="container row">
                <div className="item">
                    <span className="label">{t('tlh.ippn.processing.previousMaterialCode')}: </span>
                    <span className="value">{data.detail['Previous Material Code']}</span>
                </div>
                <div className="item">
                    <span className="label">{t('tlh.ippn.processing.newMaterialCode')}: </span>
                    <span className="value">{data.detail['New Material Code']}</span>
                </div>
            </section>
            <section className="container row">
                <div className="item">
                    <span className="label">{t('tlh.ippn.processing.newMaterialDescription')}: </span>
                    <span className="value">{data.detail['New Material Description']}</span>
                </div>
                <div className="item">
                    <span className="label">{t('tlh.ippn.processing.previousMaterialDescription')}: </span>
                    <span className="value">{data.detail['Previous Material Description']}</span>
                </div>
            </section>
            <span className="circle" > {moment(data.date).format('DD/MM/YYYY')} </span>
        </div>
    return content
}

export default ProcessingCard